import config from '@/config/config'
import API_PATH from '@/constants/apiPath'

const initialState = () => {
    return {
        cardsData: {
            shortenedUrls: 0,
            whitelistedUrls: 0,
            domainUrls: 0,
            subDomainUrls: 0
        },
        ctaTypePieChartOptions: {
            title: {
                top: '10px',
                text: 'Types of CTAs whitelisted',
                left: '5px',
                textStyle: {
                    color: config.PRIMARY_TEXT_COLOR,
                    fontWeight: 700,
                    fontSize: 14
                }
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                bottom: '15px',
                left: 'center',
                icon: 'circle'
            },
            grid: {},
            series: [
                {
                    name: 'CTA type',
                    type: 'pie',
                    radius: '50%',
                    data: [
                        { value: 1048, name: 'URL' },
                        { value: 735, name: 'Mobile' },
                        { value: 580, name: 'Email' }
                    ],
                    emphasis: {
                        itemStyle: {
                            scale: true,
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    label: {
                        show: false
                    },
                    color: config.CTATYPE_PIE_CHART_COLORS
                }
            ]
        },
        clickMetricsPieChartOptions: {
            title: {
                top: '10px',
                text: 'Clicks',
                left: '5px',
                textStyle: {
                    color: config.PRIMARY_TEXT_COLOR,
                    fontWeight: 700,
                    fontSize: 14
                }
            },
            tooltip: {
                show: true,
                trigger: 'item'
            },
            legend: {
                bottom: '15px',
                left: 'center',
                icon: 'circle'
            },
            grid: {},
            series: [
                {
                    name: 'Clicks',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['50%', '70%'],
                    startAngle: 180,
                    data: [
                        { value: 1048, name: 'Total Clicks' },
                        { value: 735, name: 'Unique Clicks' },
                        {
                            value: 1783,
                            itemStyle: {
                                // stop the chart from rendering this piece
                                color: 'none',
                                decal: {
                                    symbol: 'none'
                                }
                            },
                            label: {
                                show: false
                            }
                        }
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    label: {
                        show: false
                    },
                    color: config.CLICKMETRICS_PIE_CHART_COLORS
                }
            ]
        },
        clickTrendLineChartOptions: {
            xAxis: {
                type: 'category',
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    data: [150, 230, 224, 218, 135, 147, 260],
                    type: 'line',
                    lineStyle: {
                        color: '#2F3043'
                    },
                    label: {
                        show: true
                    }
                }
            ]
        }
    }
}

const state = initialState()

const getters = {
    getCardsData: (state) => state.cardsData,
    getCtaTypeMetrics: (state) => state.ctaTypePieChartOptions,
    getClickmetrics: (state) => state.clickMetricsPieChartOptions,
    getClickTrend: (state) => state.clickTrendLineChartOptions
}

const mutations = {
    POPULATE_WHITELISTED_ANALYTICS: (state, payload) => {
        state.cardsData.whitelistedUrls = payload[0].value
        state.ctaTypePieChartOptions.series[0].data = payload
    },
    POPULATE_SHORTENED_ANALYTICS: (state, payload) => {
        state.cardsData.shortenedUrls = payload.totalShortenedUrl
    },
    POPULATE_CLICKS_ANALYTICS: (state, payload) => {
        state.clickMetricsPieChartOptions.series[0].data = payload.allClicks
        if (payload.allClicksSum) {
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: payload.allClicksSum,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
        } else {
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: 0,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: 0,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
        }
    },
    POPULATE_CLICK_TREND: (state, payload) => {
        state.clickTrendLineChartOptions.xAxis.data = Object.keys(payload.clickTrends)
        state.clickTrendLineChartOptions.series[0].data = Object.values(payload.clickTrends)
    }
}

const actions = {
    async fetchWhitelistAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.whitelisted, payload)
            if (resp && resp.data) {
                commit('POPULATE_WHITELISTED_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchShortenedAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.shortened, payload)
            if (resp && resp.data) {
                commit('POPULATE_SHORTENED_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchClicksAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.clicks, payload)
            if (resp && resp.data) {
                commit('POPULATE_CLICKS_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchClickTrendAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.clicksTrend, payload)
            if (resp && resp.data) {
                commit('POPULATE_CLICK_TREND', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
